import Select from 'components/Select';
import {components, CSSObjectWithLabel} from 'react-select';
import styles from '../WorkerSelect.module.scss';
import {get} from 'lodash';
import Typography from 'components/Typography';
import classNames from 'classnames';
import {Link} from 'react-router-dom';
import IconUsers from 'pages/DeliveryPlanner/icons/users';

type TeamProps = {
  options: {
    label: string;
    value: string | number;
    [key: string]: any;
  };
  value?: any;
  onChange: (val: any) => void;
  selectedId?: number | string;
  color?: string;
};

const control = (base: CSSObjectWithLabel): CSSObjectWithLabel => ({
  ...base,
  minWidth: 192,
  fontSize: '14px !important',
  borderRadius: '6px !important',
});

const Team = ({options, value, selectedId, onChange}: TeamProps) => {
  return (
    <div className={styles.flex}>
      <div className={styles.teamItemHeaderIcon}>
        <IconUsers width={20} height={20} />
      </div>
      <Select
        value={value}
        options={options as any}
        getOptionValue={(option) => String(option.value)}
        getOptionLabel={(option) => String(option.label)}
        onChange={onChange}
        styles={{control}}
        menuPosition="fixed"
        isSearchable={false}
        components={{
          NoOptionsMessage: (props) => {
            return (
              <components.NoOptionsMessage {...props}>
                <Link className={styles.addNewTeamLink} to="/people/teams/new">
                  <span>+ Add new team</span>
                </Link>
              </components.NoOptionsMessage>
            );
          },
          Option: (props) => {
            return (
              <components.Option {...props}>
                <div className={styles.teamItemHeader}>
                  <div className={styles.teamItemHeaderText}>
                    <Typography
                      className={classNames(
                        styles.teamItemHeaderTextName,
                        selectedId === props.data.value && styles.activeTeam
                      )}
                    >
                      {get(props.data, 'name')}
                    </Typography>
                  </div>
                </div>
              </components.Option>
            );
          },
        }}
        placeholder="Select Team"
      />
    </div>
  );
};

export default Team;
